Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = makeIconWithDirectionMirroring;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _reactWithDirection = require('react-with-direction');

var _reactWithDirection2 = _interopRequireDefault(_reactWithDirection);

var _makeIcon = require('./makeIcon');

var _makeIcon2 = _interopRequireDefault(_makeIcon);

var _Mirror = require('./Mirror');

var _Mirror2 = _interopRequireDefault(_Mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function makeIconWithDirectionMirroring() {
  var Icon = _makeIcon2['default'].apply(undefined, arguments);

  function AnIcon(_ref) {
    var direction = _ref.direction,
        otherProps = _objectWithoutProperties(_ref, ['direction']);

    var icon = _react2['default'].createElement(Icon, otherProps);
    if (direction === _reactWithDirection.DIRECTIONS.RTL) {
      return _react2['default'].createElement(
        _Mirror2['default'],
        { inlineBlock: true },
        icon
      );
    }
    return icon;
  }

  AnIcon.displayName = 'IconWithDirection(' + String(Icon.displayName) + ')';
  AnIcon.propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _reactWithDirection.withDirectionPropTypes, _makeIcon.propTypes));
  AnIcon.defaultProps = _makeIcon.defaultProps;

  return (0, _reactWithDirection2['default'])(AnIcon);
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/private/makeIconWithDirectionMirroring.js
// module id = 61
// module chunks = 923280921217 19843951674672